import request, { BaseService, type ApiResponse } from './api'

export interface User {
  userInfo: {
    user_id: string
    account: string
    email: string
    role_id: string
    delete_flag: DeleteFlag
    create_time: string
    update_time: string
  }
  permission: Permission['permission'][]
}

export interface Permission {
  permission_id: string //主键id
  permission: string //对应权限 - 英文
  name: string // 对应权限 - 中文
  create_time: string //创建时间
  update_time: string //更新时间
  delete_flag: DeleteFlag
}

export interface Role {
  role_id: string //主键id
  role: string //偏差负责人，QA人员，IT人员
  description: string //角色描述
  permission_ids: Permission['permission_id'][] //权限
  create_time: string //创建时间
  update_time: string //更新时间
  delete_flag: DeleteFlag
  configurable: 0 | 1 // 0-可配置 1-不可配置
}

// 0，开启状态 1，关闭状态
type Status = 0 | 1
type MailNotify = {
  qa_status: Status
  worker_status: Status
}

class RoleService extends BaseService {
  async login(params: { username: string }) {
    let res = await request.postJson<ApiResponse<{ user: User }>>(
      `${this.prefix}/login`,
      params
    )
    return res!.data
  }

  /**
   * @description 查看所有权限
   */
  async getPermisions() {
    let res = await request.get<ApiResponse<{ permissions: Permission[] }>>(
      `${this.prefix}/role/permissions`
    )
    return res!.data
  }

  /**
   * @description 查看所有角色
   */
  async getRoles() {
    let res = await request.get<ApiResponse<{ roles: Role[] }>>(
      `${this.prefix}/role/roles`
    )
    return res!.data
  }

  /**
   * @description 5.6 改：修改角色权限
   */
  async updateRole(params: {
    role_id: Role['role_id']
    permission_ids: Permission['permission_id'][]
  }) {
    let res = await request.postJson(`${this.prefix}/role/update`, params)
    return res!.data
  }

  /**
   * @description 5.7 改：开启邮件通知
   * @param params qa_status: 待审核通知邮件  worker_status: 偏差待调整通知邮件
   */
  async updateMailNotify(params: MailNotify) {
    let res = await request.postJson(`${this.prefix}/mail/update`, params)
    return res!.data
  }

  /**
   * @description 5.8 查：查看邮件通知状态
   */
  async getMailNotify() {
    let res = await request.get<
      ApiResponse<{ status: { status_id: string } & MailNotify }>
    >(`${this.prefix}/mail/status`)
    return res!.data
  }
}

export default new RoleService()
